import { Box, styled } from "@mui/material";

export const Container = styled("label")(() => ({
  width: "100%",
  padding: "8px",
  borderRadius: "8px",
  border: "1px solid #D9D9D9",
  color: "#8C8C8C",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  transition: "0.3s",
  margin: 0,
  "&:hover": {
    color: "#0F110C",
    cursor: "pointer",
    transition: "0.3s",
    borderColor: "black",
    svg: {
      transition: "0.3s",
      fill: "#0F110C",
    },
  },
}));

export const ContainerPreviewDocument = styled(Box)(({ isImage = true }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: isImage ? "flex-end" : "flex-end",
  gap: !isImage ? "8px" : 0,
  borderRadius: "8px",
  backgroundColor: "transparent",
  border: "1px solid #D9D9D9",
  padding: "8px",
  width: "fit-content",
}));
